export const getters = {
  pageGroups: state => state.pageGroups.map(pageGroup => ({ id: pageGroup.id, title: pageGroup.name })),
  channelsColors: state => state.channels.map(channel => channel.hex_color),
  channelsLabels: state => state.channels.map(channel => channel.channel),
};
